"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCounter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var ACCounter = function (props) {
    var _a = React.useState(props === null || props === void 0 ? void 0 : props.value), count = _a[0], setCount = _a[1];
    // Sync with external value changes
    React.useEffect(function () {
        var newCount = Math.max(1, Math.floor(Number(props === null || props === void 0 ? void 0 : props.value) || 1));
        setCount(newCount);
    }, [props === null || props === void 0 ? void 0 : props.value]);
    // Handle increment
    var handleIncrement = function () {
        var _a;
        var newCount = count + 1;
        setCount(newCount);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, newCount);
    };
    // Handle decrement
    var handleDecrement = function () {
        var _a;
        var newCount = Math.max(1, count - 1);
        setCount(newCount);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, newCount);
    };
    // Handle manual input
    var handleInputChange = function (e) {
        var _a, _b;
        var inputValue = e.target.value;
        if (inputValue === '') {
            setCount(1);
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, 1);
        }
        else {
            var parsedValue = Math.floor(Number(inputValue));
            if (!isNaN(parsedValue) && parsedValue >= 1) {
                setCount(parsedValue);
                (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, parsedValue);
            }
        }
    };
    // Handle clear
    var handleClear = function () {
        var _a;
        setCount(1);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, 1);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 bg-slate-50 p-1 rounded-sm ".concat(props.disabled ? 'cursor-not-allowed' : '', " ").concat(props.className || ''), "data-testid": props.name, children: [(0, jsx_runtime_1.jsx)("button", { className: "w-8 h-8 bg-slate-100 hover:bg-slate-200 text-primary font-bold rounded-sm transition-all duration-300 disabled:opacity-50", onClick: handleDecrement, disabled: props.disabled || count <= 1, "data-testid": "".concat(props.name, "-decrement"), type: "button", "aria-label": "Decrease quantity", children: "-" }), (0, jsx_runtime_1.jsx)("input", { type: "number", name: props.name, id: props.name, value: count, onChange: handleInputChange, disabled: props.disabled, className: "w-12 text-center text-gray-700 bg-transparent border-none focus:outline-none", min: "1", "data-testid": "".concat(props.name, "-input"), "aria-label": "Quantity input" }), (0, jsx_runtime_1.jsx)("button", { className: "w-8 h-8 bg-slate-100 hover:bg-slate-200 text-primary font-bold rounded-sm transition-all duration-300 disabled:opacity-50", onClick: handleIncrement, disabled: props.disabled, "data-testid": "".concat(props.name, "-increment"), type: "button", "aria-label": "Increase quantity", children: "+" })] }));
};
exports.ACCounter = ACCounter;
